module.exports = __webpack_public_path__ + "static/media/slider-phone-2.641483fd.jpg";